(() => {
  const video = document.querySelector('.hero-background-video');
  const toggle = document.querySelector('.hero-video-toggle');
  if (!video || !toggle) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let loaded = false;
  let userPaused = reducedMotion.matches || Boolean(navigator.connection?.saveData);
  let visible = true;
  const load = () => {
    if (loaded) return;
    video.querySelectorAll('source').forEach(source => { source.src = source.dataset.src; });
    video.muted = true;
    video.load();
    loaded = true;
  };
  const play = () => {
    if (userPaused || !visible || document.hidden) return;
    load();
    video.play().catch(() => { toggle.textContent = 'Play video'; toggle.setAttribute('aria-label', 'Play background video'); });
  };
  const update = () => {
    toggle.textContent = video.paused ? 'Play video' : 'Pause video';
    toggle.setAttribute('aria-label', video.paused ? 'Play background video' : 'Pause background video');
  };
  video.addEventListener('play', update);
  video.addEventListener('pause', update);
  toggle.addEventListener('click', () => {
    userPaused = !video.paused;
    if (userPaused) video.pause(); else play();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (!visible) video.pause(); else if (loaded) play();
    }, { threshold: 0.05 }).observe(video);
  }
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else if (loaded) play(); });
  reducedMotion.addEventListener('change', event => { userPaused = event.matches; if (userPaused) video.pause(); else play(); });
  const start = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(play, { timeout: 1000 });
    else window.setTimeout(play, 200);
  };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
})();
